export const glPurple = "#A7345C";
export const glPurpleDimmed = "#82315F";
export const glPurpleLight = "#D83957";
export const menuBg = "#2b2b2b";
